import * as R from 'ramda'
import camelCase from 'camelcase'
import fastSafeStringify from 'fast-safe-stringify'

// stringify that can handle exotic objects e.g. with cyclical references
// useful for debugging and stringifying javascript errors etc.
export const stringify = (
  obj: unknown,
  replacer?: Parameters<typeof JSON.stringify>[1],
  space?: Parameters<typeof JSON.stringify>[2],
): string => {
  const safeReplacer = typeof replacer === 'function' ? replacer : undefined

  try {
    return JSON.stringify(obj, replacer, space)
  } catch (e) {
    return fastSafeStringify(obj, safeReplacer, space, {
      depthLimit: 4,
      edgesLimit: 50,
    })
  }
}

// convert python style snake_case to camelCase in json objects
export const camelConverter = (obj: unknown): unknown =>
  R.cond([
    [R.is(Array), R.map(camelConverter)],
    [
      R.is(Object),
      R.pipe(
        R.toPairs,
        R.map(([key, val]) => [
          key.match(/_/) ? camelCase(key) : key,
          camelConverter(val),
        ]),
        R.fromPairs,
      ),
    ],
    [R.T, R.identity],
  ])(obj)
